export default {
    assigned_book: 'Your assigned book',
    challenges: 'Challenges',
    challenges_desc: 'Overcome challenges and win prizes.',
    empty_messages: 'No messages',
    empty_notifications: 'No notifications',
    my_books: 'My books',
    my_profile: 'My profile',
    my_subscriptions: 'My subscriptions',
    news_from_library: 'Library news',
    news_from_store: 'News from your store',
    no_book: 'You have no book assigned this month.',
    no_super_recommended: 'We have no recommendations at the momment.',
    pending_readings: 'Your pending readings',
    pending_readings_desc: 'Go ahead and finish your books.',
    ranking: 'Ranking',
    ranking_desc: 'Know the best scores.',
    reminder: 'Reminder',
    start_reading: 'Start reading',
    store: 'Store',
    store_desc: 'Buy with your Beecoins.',
    super_recommended: 'Super recommended!',
    do_click: 'You must click to see the message',
    no_message: 'No message to display',
    notification_text_1:
    'Remember to continue with your assigned book before time runs out. If you want to resume reading, click here. ',
    notification_text_2:
        'You are about to have a unique reading experience. Enjoy the recommendations we have for you. Access immediately and enjoy your suggested readings. ',
    notification_text_3:
        'Everything you need to decorate your platform with a single click. Access amazing additional tools. ',
}
